import ImageKit from 'imagekit-javascript'
import { pathFromAWSUrl } from './aws_path'

export const ImageKitURLEndpoint = import.meta.env.VITE_IMAGEKIT_ENDPOINT
export const PublicKey = import.meta.env.VITE_IMAGEKIT_PUBLIC_KEY

const imagekit = new ImageKit({
  urlEndpoint: ImageKitURLEndpoint
})

export function urlFromAWSUrl(awsUrl, transformation) {
  let path = pathFromAWSUrl(awsUrl)
  if (!path) {
    return ''
  }

  return imagekit.url({
    path,
    urlEndpoint: ImageKitURLEndpoint,
    transformation
  })
}